
import Vue from 'vue'
import { newSearch } from '../store/actions';
import { IFilter } from '../store/state';
import FilterComponent from '../components/Filter.vue';

interface FiltersData {}

interface FiltersMethods {
    removeAllFilters(): void
}

interface FiltersComputed {
    filters: IFilter[],
    selectedBoard: string,
    selectedParty: string,
    query: string,
}


export default Vue.extend<FiltersData, FiltersMethods, FiltersComputed, {}>({
	name: 'FiltersComponent',
	methods: {
        removeAllFilters() {
            this.$store.commit({
                type: 'setSelectedBoard',
                payload: ''
            });
            this.$store.commit({
                type: 'setSelectedParty',
                payload: ''
            });
            this.$store.commit({
                type: 'setQuery',
                payload: ''
            });
            this.$store.dispatch(newSearch(null))
        }
	},
	computed: {
        query() {
            return this.$store.state.query;
        },
        selectedBoard() {
            return this.$store.state.selectedBoard;
        },
        selectedParty() {
            return this.$store.state.selectedParty;
        },
		filters() {
            return this.$store.state.filters;
        }
	},
    components: {
        FilterComponent
    }
})
